/* eslint-disable no-undef */

export default {
	name: "link-unlink-customers-to-discount-group",
	props: ["companyId", "elementId", "showModal", "heading"],
	emits: ["saveComplete", "modalClose"],
	data() {
		return {
			customerDiscountGroupCustomers: [],
			unassignedDepotDiscountGroups: [],
			assignedDepotDiscountGroups: [],
			depotDiscountGroups: [],
			depotDiscountGroupsHeadings: [
				{
					text: "Name",
					field: "name"
				},
				{
					text: "Depot",
					field: "depot"
				},
				{
					text: "Discount Amount",
					field: "discountAmountAsString"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			assignFilterStateChanged: false,
			unassignedFilterStateChanged: false,
			assignedFilter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			unassignedFilter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			newAssignedCustomers: [],
			newUnassignedCustomers: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false
		};
	},
	methods: {
		getDiscountGroupsForCompany(){
			this.loading = true;
			let request = {
				companyId: this.companyId
			};
			orderService.getDiscountGroupsForCompany(request).then(
				successResponse => {
					this.loading = false;
					this.depotDiscountGroups = successResponse.data.result;
					for(let i = 0; i < this.depotDiscountGroups.length; i++) {
						this.depotDiscountGroups[i].discountAmountAsString = currencyHelper.numberToCurrency(this.depotDiscountGroups[i].discountAmount);
					}
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onLinkedToCustomerCheckboxChange(depotDiscountGroup){
			console.log("depotDiscountGroup", depotDiscountGroup);
			if(depotDiscountGroup.linkedToCustomer){
				this.assignedDepotDiscountGroups.push(depotDiscountGroup.discountGroupId);
				this.unassignedDepotDiscountGroups = this.unassignedDepotDiscountGroups.filter(function(value, index, arr){
					return value !== depotDiscountGroup.discountGroupId;
				});
			}
			else{
				this.unassignedDepotDiscountGroups.push(depotDiscountGroup.discountGroupId);
				this.assignedDepotDiscountGroups = this.assignedDepotDiscountGroups.filter(function(value, index, arr){
					return value !== depotDiscountGroup.discountGroupId;
				});
			}
			console.log("assignedDepotDiscountGroups", this.assignedDepotDiscountGroups);
			console.log("unassignedDepotDiscountGroups", this.unassignedDepotDiscountGroups);
		},
		unassignCustomerFromSalesRep(customerId){
			this.newUnassignedCustomers.push(customerId);
			console.log("customerId", customerId);
			for(var i = 0; i < this.customerDiscountGroupCustomers.length; i++){
				if(this.customerDiscountGroupCustomers[i].companyId === customerId){
					this.unassignedCustomers.push(this.customerDiscountGroupCustomers[i]);
					this.customerDiscountGroupCustomers.splice(i, 1);
					break;
				}
			}
			for(var j = 0; j < this.newAssignedCustomers.length; j++){
				if(this.newAssignedCustomers[j] === customerId){
					this.newAssignedCustomers.splice(j, 1);
					break;
				}
			}
		},
		assignCustomerFromSalesRep(customerId){
			this.newAssignedCustomers.push(customerId);
			console.log("customerId", customerId);
			for(var i = 0; i < this.unassignedCustomers.length; i++){
				if(this.unassignedCustomers[i].companyId === customerId){
					this.customerDiscountGroupCustomers.push(this.unassignedCustomers[i]);
					this.unassignedCustomers.splice(i, 1);
					break;
				}
			}
			for(var j = 0; j < this.newUnassignedCustomers.length; j++){
				if(this.newUnassignedCustomers[j] === customerId){
					this.newUnassignedCustomers.splice(j, 1);
					break;
				}
			}
		},
		clearMessageAlerts(){
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;

			this.$router.go(-1);
		},
		onModalCloseClick() {
			this.$emit("modalClose", true);
		},
		onModalSaveClick(){
			//save changes
			this.loading = true;
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;
			
			let request = {
				discountGroupIdsToLink: this.assignedDepotDiscountGroups,
				discountGroupIdsToUnlink: this.unassignedDepotDiscountGroups,
				companyId: this.companyId
			};
			orderService.linkDiscountGroupsToCompany(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.$emit("saveComplete", true);
					}
					else{
						this.$emit("saveComplete", false);
					}
					$("#" + this.elementId).modal("hide");
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					$("#" + this.elementId).modal("hide");
					this.loading = false;
					this.$emit("saveComplete", false);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		}
	},
	mounted: function () {
	},
	watch: {
		// companyId:{
		// 	handler: function () {
		// 		if(this.companyId !== null && this.companyId !== undefined && this.companyId !== "" && this.companyId > 0) {
		// 			this.getDiscountGroupsForCompany();
		// 		}
		// 	},
		// 	immediate: true,
		// 	deep: true
		// },
		showModal: {
			handler: function () {
				if(this.showModal){
					$("#" + this.elementId).modal("show");
					if(this.companyId !== null && this.companyId !== undefined && this.companyId !== "" && this.companyId > 0) {
						this.getDiscountGroupsForCompany();
					}
				}
				else{
					$("#" + this.elementId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		}
	}
};
